// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mergeWithCss, parseBoolean } from "@west/XDL/Utilities";
import React, { FC, useState } from "react";

interface OwnProps {
    westNonReturnable?: string;
    extendedStyled?: NonReturnableStyles;
}

type Props = OwnProps;

export interface NonReturnableStyles {
    message?: TypographyPresentationProps;
}

export const nonReturnableStyles: NonReturnableStyles = {};

const NonReturnable: FC<Props> = ({ westNonReturnable, extendedStyled }) => {
    const [styles] = useState(() => mergeWithCss(nonReturnableStyles, extendedStyled));

    if (!westNonReturnable) {
        return null;
    }

    return (
        <Typography {...styles.message} data-test-selector="west_non_returnable">
            {westNonReturnable}
        </Typography>
    );
};

export default NonReturnable;
